import React from 'react'
import { useSelector } from 'react-redux'

import { parsePhone, getHelpLink } from 'services/Utilities'
import { TrackAction } from 'services/TrackAction'
import BaseModal from 'components/Modals/BaseModal'

import { t } from 'translations'

const ImportantInformationModal = () => {
  const { userInfo: { username, employeeNumber } = {} } = useSelector(state => state.users)
  const { co } = useSelector(state => state.auth)
  const { twilioNumber } = useSelector(state => state.settings)

  return (
    <BaseModal title="components.topBar.IMPORTANT_INFORMATION_MODAL">
      {username === employeeNumber ? (
        <>
          <div className="text-muted">
            {t('components.topBar.IMPORTANT_INFORMATION_MODAL.USERNAME')} / {t('components.topBar.IMPORTANT_INFORMATION_MODAL.EMPLOYEE_NUMBER')}
          </div>
          <h5 className="font-weight-bold">{employeeNumber}</h5>
        </>
      ) : (
        <>
          <div className="text-muted">{t('components.topBar.IMPORTANT_INFORMATION_MODAL.USERNAME')}</div>
          <h5 className="font-weight-bold">{username}</h5>

          <div className="text-muted">{t('components.topBar.IMPORTANT_INFORMATION_MODAL.EMPLOYEE_NUMBER')}</div>
          <h5 className="font-weight-bold">{employeeNumber}</h5>
        </>
      )}

      {twilioNumber ? (
        <>
          <div className="text-muted">{t('components.topBar.IMPORTANT_INFORMATION_MODAL.TWILIO_PHONE')}</div>
          <h5 className="font-weight-bold">{parsePhone(twilioNumber.substr(1))}</h5>
        </>
      ) : null}

      <div className="text-muted">{t('components.topBar.IMPORTANT_INFORMATION_MODAL.COMPANY_ID')}</div>
      <h5 className="font-weight-bold">{co}</h5>

      <div className="text-muted">{t('components.topBar.IMPORTANT_INFORMATION_MODAL.HELP_CENTER')}</div>
      <h5 className="font-weight-bold">
        <a
          href="#"
          rel="noopener noreferrer"
          onClick={() => {
            // Track opening help center in intercom
            TrackAction('OPEN_HELP_CENTER', { to: getHelpLink('helpCenter'), from: 'importantInformationModal' })
            window.open(getHelpLink('helpCenter'), '_blank')
          }}
        >
          help.merinio.com
        </a>
      </h5>
    </BaseModal>
  )
}

export default ImportantInformationModal
